module.exports = __webpack_public_path__ + "img/L3.16fc6dc1.jpg";